module.exports = __webpack_public_path__ + "media/images/icons/icon-question-0c86d36b4071daa15aee847046be520c.svg";